import { render, staticRenderFns } from "./Stask.vue?vue&type=template&id=5905f40b&"
import script from "./Stask.vue?vue&type=script&lang=js&"
export * from "./Stask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports